import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';
import { formatCurrency } from '../../../../../CommonUtils/formatNumber';

export const DonationAmountReview = () => {
  const {
    workflow: {
      data: { donationAmount, maximizeDonations },
    },
  } = useCharitableGivingContext();

  const formattedDonationAmount =
    donationAmount !== null ? formatCurrency(donationAmount, { mantissa: 2 }) : '—';

  return (
    <ReviewItem
      label="Donation Amount"
      value={maximizeDonations ? 'Maximize Donations' : formattedDonationAmount}
    />
  );
};
